import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCamera, FaHatWizard, FaGamepad, FaCocktail } from 'react-icons/fa';
import './About.css';
import profileImage from '../../assets/images/profile.jpeg';

const About = () => {
  return (
    <section id="about" className="about-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Profile Image with card-themed frame for magic interest */}
          <Col lg={4} className="mb-5 mb-lg-0">
            <div className="profile-image-container">
              <div className="card-frame">
                <div className="profile-image">
                  <img
                    src={profileImage}
                    alt="David Yakubov"
                    className="img-fluid"
                  />

                  {/* Card suit indicators in corners (for magic interest) */}
                  <div className="card-suit top-left">♥</div>
                  <div className="card-suit top-right">♦</div>
                  <div className="card-suit bottom-left">♣</div>
                  <div className="card-suit bottom-right">♠</div>
                </div>
              </div>
            </div>
          </Col>

          {/* About Content */}
          <Col lg={8}>
            <div className="section-heading mb-4">
              <h2 className="display-5 fw-bold">About Me</h2>
              <div className="heading-underline"></div>
            </div>

            <p className="lead mb-4">
              I'm a software engineer based in Atlanta with experience across enterprise web development, applied AI, and internal business systems.
            </p>

            <p className="mb-4">
              At BigPanda, I owned the ingestion and indexing pipeline for a customer-facing AI assistant, working with
               Python, embeddings, vector search, Slack data, and machine-learning prototypes. At Accenture, I developed 
               enterprise applications with Angular and TypeScript for a heavy machinery manufacturer and later built WordPress/PHP 
               functionality for a pharmeceutical company.
            </p>

            <p className="mb-4">
              More recently, I've applied the same engineering mindset inside a luxury residential construction business, designing 
              systems that manage more than 100 contractors and over $5.6 million in recorded check payments while automating payment, 
              accounting, compliance, and documentation workflows.
            </p>

            <p className="mb-4">
              I tend to gravitate toward ambiguous problems where the solution isn't obvious—understanding the business first, then 
              deciding what technology actually makes sense.
            </p>

            {/* Personal interests with subtle styling cues */}
            <Card className="interest-card mt-4">
              <Card.Body>
                <h5 className="fw-bold mb-3">Beyond Coding</h5>

                <Row xs={2} md={4} className="g-3 text-center">
                  {/* Photography */}
                  <Col>
                    <div className="interest-icon">
                      <FaCamera />
                    </div>
                    <p className="interest-label">Photography</p>
                  </Col>

                  {/* Magic */}
                  <Col>
                    <div className="interest-icon magic">
                      <FaHatWizard />
                    </div>
                    <p className="interest-label">Magic</p>
                  </Col>

                  {/* Gaming */}
                  <Col>
                    <div className="interest-icon gaming">
                      <FaGamepad />
                    </div>
                    <p className="interest-label">Gaming</p>
                  </Col>

                  {/* Bartending */}
                  <Col>
                    <div className="interest-icon bartending">
                      <FaCocktail />
                    </div>
                    <p className="interest-label">Bartending</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;